import React from 'react';
import { useStyles } from './AccountDashboardPlanWidget.utils';
import OverflowTooltip from '../../../components/OverflowTooltip/OverflowTooltip';
import {useTranslation} from 'react-i18next';
import { CounterInterface } from '../../../store/types/CustomerAgreementCondition';
import classNames from 'classnames';
import BundleRow from '../../../components/Dashboard/BundleSection/BundleRow';

export type AccountDashboardPlanWidgetCounterProps = {
    productName: string;
    counters: CounterInterface[];
    isShared?: boolean;
    isAddOn?: boolean;
};

const AccountDashboardPlanWidgetCounter: React.VFC<AccountDashboardPlanWidgetCounterProps> = ({
    productName,
    counters,
    isShared = false,
    isAddOn = false,
}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (<>
        <div className={classes.productNameContainer}>
            <div className={classes.productName}>
                <OverflowTooltip
                    tooltip={productName}
                    text={productName}
                    copy={false}
                />
            </div>
            <div className={classNames(classes.mainProduct, isShared && classes.sharedProduct)}>
                {isAddOn
                ? t('screens:accountDashboard.addOn') 
                    : isShared
                    ? t('screens:accountDashboard.shared') 
                    : t('screens:dashboard.mainProduct')}
            </div>
        </div>
        <div className={classes.counterContainer}>
            {counters?.map((v, index) => (
                <BundleRow key={v.i_vd_dg} product={v} lastRow={index == ((counters?.length ?? 0) - 1)}
                    customClasses={{
                        mainContainer: classes.productsSectionMainContainer,
                        firstLine: classes.productsSectionFirstLine,
                        secondLine: classes.productsSectionSecondLine,
                        linearProgressContainer: classes.productsSectionLinearProgressContainer,
                        linearProgress: classes.productsSectionLinearProgress,
                        valuesContainer: classes.productsSectionValuesContainer,
                        usedQuantity: classes.productsSectionUsedQuantity,
                        maxQuantity: classes.productsSectionMaxQuantity,
                        thirdColumn: classes.productsSectionThirdColumn,
                        mainProductLabel: classes.productsSectionMainProductLabel
                    }} />
            ))}
        </div>
    </>);
}

export default AccountDashboardPlanWidgetCounter;